export default {
  getCookieSettings: function () {
    return JSON.parse(
      window.localStorage.getItem('nsd-accept-cookies')
    )
  },
  setCookieSettings: function (serializedSettings) {
    window.localStorage.setItem('nsd-accept-cookies', serializedSettings)
  }
}
